import { useState } from 'react';
import { Button } from '@/components/ui/button';
import RetirementForm from './RetirementForm';
import { useAppContext } from '@/contexts/AppContext';

const Hero = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { heroVideo } = useAppContext();

    return (
    <>
      <section className="relative bg-gradient-to-br from-slate-700 via-slate-600 to-slate-800 text-white py-12 sm:py-16 md:py-20 overflow-hidden">
        {/* Background Video */}
        {heroVideo && (
          <div className="absolute inset-0 z-0">
            <video 
              autoPlay 
              muted 
              loop 
              playsInline
              className="w-full h-full object-cover opacity-70"
              onError={(e) => {
                console.error('Video failed to load:', e);
              }}
            >
              <source src={heroVideo} type="video/mp4" />
            </video>
          </div>
        )}
        
        {/* Reduced Gradient Overlay - Made more transparent */}
        <div className="absolute inset-0 z-10 bg-gradient-to-br from-slate-700/40 via-slate-600/30 to-slate-800/50"></div>
        
        <div className="container mx-auto px-4 sm:px-6 relative z-20">
          <div className="flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto">
            <div className="text-center md:text-left md:flex-1 mb-8 md:mb-0">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-white to-slate-100 bg-clip-text text-transparent drop-shadow-lg leading-tight">
                Dan Casey
              </h1>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-3 sm:mb-4 text-white drop-shadow-md leading-snug">
                Registered Investment Adviser Representative &amp; Fiduciary
              </p>
              <p className="text-sm sm:text-base mb-4 sm:mb-6 text-slate-100 max-w-2xl mx-auto md:mx-0 drop-shadow-md leading-relaxed">
                Dan is the founder of Bridgeriver Advisors, a registered investment advisory firm in Michigan. As a published author and speaker, Dan shares his straightforward approach to financial planning with audiences nationwide. As a fiduciary, he is committed to acting in his clients' best interests.
              </p>
              <p className="text-sm sm:text-base mb-6 sm:mb-8 text-slate-100 max-w-2xl mx-auto md:mx-0 drop-shadow-md leading-relaxed">
                He aims to simplify the financial landscape so clients can better understand their financial picture and work toward their retirement goals. Bridgeriver Advisors strives to provide transparent, fee-conscious advisory services.
              </p>
              <Button 
                size="lg" 
                className="bg-red-600 hover:bg-red-700 text-white font-bold px-5 sm:px-8 py-3 text-sm sm:text-base lg:text-lg shadow-xl transform hover:scale-105 transition-all duration-200 whitespace-normal leading-snug"
                onClick={() => setIsFormOpen(true)}
              >
                Request a Complimentary Retirement Analysis
              </Button>
              <p className="text-xs text-slate-300 mt-3 max-w-md mx-auto md:mx-0">
                No obligation. For informational purposes only. Not a guarantee of future results.
              </p>
            </div>
            <div className="md:flex-1 flex justify-center md:justify-end">
              <div className="relative">
                <div className="w-56 h-56 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden border-4 border-slate-400 shadow-2xl transform hover:scale-105 transition-all duration-300">
                  <img 
                    src="https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750633784318_a7e949a2.jpeg" 
                    alt="Dan Casey - Registered Investment Adviser Representative"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <RetirementForm 
        isOpen={isFormOpen} 
        onClose={() => setIsFormOpen(false)} 
      />
    </>
  );
};

export default Hero;
